import { writable, get } from 'svelte/store';
import Flags from '../lib/flags';

// Check, if archive functionality should be available
let enableArchive = true; //!!Flags.get('archive');

const store = writable({
    baseWeb: getBaseWeb(),
    archiveEnabled: enableArchive
});

function getBaseWeb() {
    const host = location.host;
    const proto = location.protocol;
    const baseHost = host.replace(/^[^.]+/, '');

    return `${proto}//` + (/^rezervace\./.exec(host) ? 'www' : 'test') + baseHost;
}

export default {
    subscribe: store.subscribe,
    set: store.set,
    get: get(store)
}
